// extracted by mini-css-extract-plugin
export default {"resetPassContainer":"v2_oAOUFZTdZ3WRhlhKg","backToResetPassword":"TVgpKCKfoPhiI4wVS1oB","submit":"augtD1VWgqin2PWC0fHO"};